'use client'

import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { MarketingPopoverSchema } from 'cms/schemaTypes/layout/marketingPopover'
import { useSearchParams } from 'next/navigation'

import { internalApi, QueryKey } from 'shared/api'
import { isClient } from 'shared/utils/common'

// Same cache logic like in the ribbon.
const CACHE_TIME_MS = 1000 * 60 * 60 * 4

export const useQueryMarketingPopover = (enabled: boolean) => {
  const params = useSearchParams()
  // Lets the CMS preview link show a popover that is still switched off.
  const token = useMemo(() => params?.get('token') ?? null, [params])

  return useQuery({
    queryKey: [QueryKey.marketingPopover, token],
    queryFn: async () => {
      const response = await internalApi.get<MarketingPopoverSchema | null>(
        '/marketing-popover',
        { params: { token } }
      )

      return response.data
    },
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: CACHE_TIME_MS,
    gcTime: isClient() ? CACHE_TIME_MS : Infinity
  })
}
